import phoneValidation from './phoneValidation.es';

export default {
  ...phoneValidation,
};
